import { render } from "./MinimalConnect.vue?vue&type=template&id=92e73dda&ts=true"
import script from "./MinimalConnect.vue?vue&type=script&lang=ts"
export * from "./MinimalConnect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/connect-widgets/connect-widgets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__